<footer class="footer ">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul class="menu-underline" data-animation="center">
        <li>
           <button type="button" class="hand-cursor language-option"
             [ngClass]="{'active-lang': selectedLanguage == 'es'}"
             (click)="changeLanguage('es')">
            {{'language.es' | translate}}
           </button>
        </li>
        <li>
            <button type="button" class="hand-cursor language-option"
              [ngClass]="{'active-lang': selectedLanguage == 'en'}"
              (click)="changeLanguage('en')">
            {{'language.en' | translate}}
            </button>
        </li>
      </ul>
    </nav>
    <!--<div class="copyright pull-right">
      &copy;
      {{test | date: 'yyyy'}}, made with <i class="material-icons">favorite</i> by
      <a href="https://www.creative-tim.com" target="_blank">Creative Tim</a> for a better web.
    </div>-->
  </div>
</footer>
